<div class="modal-overlay" *transloco="let t; prefix: 'driverShared'">
  <div class="modal-content">
    <div class="title">
      <label>{{ modalTitle }}</label>
    </div>

    <!-- Search - Only for bulk mode -->
    @if (config.showSearch) {
      <div>
        <div class="input-group align-items-center">
          <div class="col-1 ps-2 d-flex justify-content-center align-items-center rounded-start-3 border-1 search-icon">
            <i class="ph ph-magnifying-glass"></i>
          </div>
          <div class="col-11">
            <input type="text" class="ps-3 rounded-end-3 border-1 search-input" [attr.aria-label]="'accountFilter.search' | transloco"
              [placeholder]="t('assignmentModal.searchDriversOrVehicles')" [(ngModel)]="searchTerm" (input)="onSearch()" />
            </div>
          </div>
        </div>
      }

      @if (config.confirmationMessage) {
        <div class="confirmation-msg-title">
          <span [innerHtml]="config.confirmationMessage"></span>
        </div>
      }

      <!-- Confirmation warning -->
      @if (config.showConfirmationWarning) {
        <div class="confirmation-msg">
          <svg width="65" height="65" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z"
              fill="#FF7F00" />
              <path
                d="M22.8842 12.532C22.5382 11.878 21.4622 11.878 21.1162 12.532L12.1162 29.532C11.9522 29.842 11.9622 30.216 12.1432 30.515C12.3242 30.816 12.6492 31 13.0002 31H31.0002C31.3512 31 31.6762 30.816 31.8562 30.516C32.0382 30.216 32.0472 29.842 31.8832 29.533L22.8842 12.532ZM23.0002 28H21.0002V26H23.0002V28ZM21.0002 24V19H23.0002L23.0012 24H21.0002Z"
                fill="#F7F5F5" />
              </svg>
              @if (config.warningMessage) {
                <span>
                  {{config.warningMessage}}
                </span>
              }
            </div>
          }

          <div class="contents-container">
            <!-- Asset Filter - Only for single assign mode -->
            @if (config.showAssetFilter) {
              <div>
                <div>
                  <label>{{ t('assignmentModal.vehicleAccount') }}</label>
                </div>
                <div>
                  <app-asset-assignment-filter [filter]="config.assignmentFilter" [tree]="config.hierarchicalAssetsTree!"
                    [entityType]="'asset'" [labelTitle]="t('assignmentModal.selectVehiclesToAssign')"
                    [isLoaded]="config.assetsLoaded" (driverAssignmentFilterChanged)="onFilterChanged($event)">
                  </app-asset-assignment-filter>
                </div>
              </div>
            }

            <!-- Drivers List - Only for bulk mode -->
            @if (config.showDrivers) {
              <div>
                <label>{{ t('assignmentModal.driversSelected', { count: driversCount }) }}</label>
                @if (flatDriversModalList.length > 0) {
                  <div>
                    <cdk-virtual-scroll-viewport itemSize="27" class="modal-viewport" [style.max-height.px]="250">
                      <ng-container *cdkVirtualFor="let entry of flatDriversModalList">
                        @if (entry.rowType === 'group') {
                          <div class="group-header">
                            <label>{{ entry.accountName }}</label>
                            <label>
                              <span>({{ entry.count }})</span>
                              <span (click)="toggleCollapse(entry.accountName, 'driver'); $event.stopPropagation()"
                                class="collapse-arrow">
                                <i [ngClass]="entry.collapsed ? 'ph ph-caret-up' : 'ph ph-caret-down'"></i>
                              </span>
                            </label>
                          </div>
                        }
                        @if (entry.rowType === 'item') {
                          <div class="group-item">
                            {{ entry.name }}
                          </div>
                        }
                      </ng-container>
                    </cdk-virtual-scroll-viewport>
                  </div>
                }
              </div>
            }

            <!-- Assets List -->
            @if (config.showAssets) {
              <div>
                @if (assetsCount > 0) {
                  <div>
                    <label>{{ t('assignmentModal.assetsSelected', { count: assetsCount }) }}</label>
                    @if (flatAssetsModalList.length > 0) {
                      <div>
                        <cdk-virtual-scroll-viewport itemSize="27" class="modal-viewport" [style.max-height.px]="250">
                          <ng-container *cdkVirtualFor="let entry of flatAssetsModalList">
                            @if (entry.rowType === 'group') {
                              <div class="group-header">
                                <label>{{ entry.accountName }}</label>
                                <label>
                                  <span>({{ entry.count }})</span>
                                  <span
                                    (click)="toggleCollapse(entry.accountName, config.mode === 'bulk' ? 'asset' : undefined); $event.stopPropagation()"
                                    class="collapse-arrow">
                                    <i [ngClass]="entry.collapsed ? 'ph ph-caret-up' : 'ph ph-caret-down'"></i>
                                  </span>
                                </label>
                              </div>
                            }
                            @if (entry.rowType === 'item') {
                              <div class="group-item">
                                {{ entry.name }}
                              </div>
                            }
                          </ng-container>
                        </cdk-virtual-scroll-viewport>
                      </div>
                    }
                  </div>
                }
              </div>
            }

            <!-- Unassign Confirmation Input -->
            @if (config.showConfirmationMessage) {
              <div>
                <div class="unassign-lbl">
                  <label>{{confirmationPlaceholder}}</label>
                </div>
                <div class="align-items-center">
                  <input type="text" class="ps-3 confirmation-input" [attr.aria-label]="'accountFilter.search' | transloco" [placeholder]="confirmationPlaceholder"
                    [(ngModel)]="confirmationText" required />
                  </div>
                </div>
              }
            </div>

            <div class="button-group form-group">
              <button type="button" class="cancel-btn" (click)="close()">{{ cancelText }}</button>
              <button type="submit" class="save-btn" (click)="performAction()"
                [disabled]="isActionDisabled || !isAssetsSelected">
                @if (!isLoading) {
                  <span> {{ confirmText }} </span>
                }
                @if (isLoading) {
                  <span class="spinner-border d-flex justify-content-center align-items-center"></span>
                }
              </button>
            </div>
          </div>
        </div>